import { useRef, useEffect } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import useKeyboardOpenStatus from './useKeyboardOpenStatus';
smoothscroll.polyfill();
const useScrollToInput = () => {
    const inputRef = useRef(null);
    const isKeyboardOpen = useKeyboardOpenStatus();
    useEffect(() => {
        if (isKeyboardOpen) {
            if (inputRef.current) {
                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                if (isIOS) {
                    setTimeout(() => {
                        inputRef.current.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
                    }, 10);
                }
                else {
                    inputRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        }
    }, [isKeyboardOpen]);
    return inputRef;
};
export default useScrollToInput;
